import { LISTAR_GRUPOS_CAPTURA, LISTAR_GRUPO_CAPTURA_SELECIONADO } from './mutation-types'

import GruposHttpService from '../_services/GruposHttpService'

export default {
  listarGruposCaptura: async ({ commit }) => {
    try {
      const response = await GruposHttpService.getGrupos()
      commit(LISTAR_GRUPOS_CAPTURA, response.data)
    } catch (e) {
      console.log(e)
    }
  },
  listarGrupoCapturaSelecionado: async ({ commit }, _id) => {
    try {
      const response = await GruposHttpService.getGrupo(_id)
      commit(LISTAR_GRUPO_CAPTURA_SELECIONADO, response.data)
    } catch (e) {
      console.log(e)
    }
  },
}
